// src/components/Confirmation.js
import React, { useEffect, useState, useContext } from "react";

import Footer from "./Footer";
import BackToTopButton from "./BackToTop";

//import "./conformpage.css";
import { CarrierContext } from "../contexts/CarrierContext";
import { LanguageContext } from "../contexts/LanguageContext";
import HeaderPayment from "./HeaderPayment";
import Breadcrumbs from "./Breadcrumbs";
import { dompurifyHtml } from "../utils/sanitizeInput";

const Glossary = () => {
  const carrierContxt = useContext(CarrierContext);
  const urlCarrier = carrierContxt.hasOwnProperty("carrier")
    ? carrierContxt.carrier
    : null;

  const { cmsAllPages, handleLanguage, langErr } = useContext(LanguageContext);
  const [cms, setConfirmationCMS] = useState("");
  const [langSelected, setLangSelected] = useState(
    () => sessionStorage.getItem("langSel") || "eng"
  ); // default language

  useEffect(() => {
    if (cmsAllPages && cmsAllPages.glossary) {
      setConfirmationCMS(cmsAllPages.glossary);
    }
  }, [cmsAllPages, setConfirmationCMS]);

  return (
    <>
      <div id="main-glossary-contents">
        <div id={`header-${urlCarrier}`}>
          <HeaderPayment
            page="glossary"
            setLangSelected={setLangSelected}
          ></HeaderPayment>
        </div>

        <main id="main" className="main">
          <div>
            <Breadcrumbs cms={cms}></Breadcrumbs>
          </div>
          <div
            dangerouslySetInnerHTML={{
              __html: dompurifyHtml(cms?.glossary_content),
            }}
          />
        </main>

        <BackToTopButton></BackToTopButton>

        <Footer cms={cms}></Footer>
      </div>
    </>
  );
};

export default Glossary;
